import React from 'react';
import { Link } from 'react-router-dom';

const RealEstate = () => {
    return (
        <div className="bg-gray-50 pt-24 pb-16 px-6 md:px-20">
            <div className="max-w-6xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-extrabold text-[#0c24da] mb-4">Real Estate Services</h1>
                    <h2 className="text-2xl font-semibold text-gray-700">Your Trusted Real Estate Partner – Rajkuruma</h2>
                    <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                        At Rajkuruma, we provide comprehensive real estate solutions tailored to meet your needs. Whether you are looking to buy, sell, rent, or invest, our team is dedicated to helping you find the perfect opportunity.
                    </p>
                </div>

                {/* Core Solutions Grid */}
                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    <SolutionCard
                        title="Office Leasing"
                        desc="Premium office spaces for modern businesses, from co-working to corporate offices."
                        features={['Prime Locations', 'Flexible Lease Options', 'Fully Furnished/Unfurnished', 'Transparent Process']}
                    />
                    <SolutionCard
                        title="Residential Apartments"
                        desc="Find your perfect home with our wide range of modern and comfortable apartment options."
                        features={['Premium & Affordable', 'Modern Amenities', 'Secure Communities', 'Excellent Connectivity']}
                    />
                    <SolutionCard
                        title="Property Management"
                        desc="Stress-free management solutions for property owners to maximize returns."
                        features={['Tenant Management', 'Rent Collection', 'Maintenance Coordination', 'Regular Inspections']}
                    />
                    <SolutionCard
                        title="Relocation Assistance"
                        desc="Smooth transition services whether you're moving for work, education, or personal reasons."
                        features={['Home Search', 'Rental/Purchase Guidance', 'Local Area Orientation', 'Moving Coordination']}
                    />
                </div>

                {/* Why Choose Us */}
                <div className="bg-white p-10 rounded-3xl shadow-lg border-l-8 border-[#f15a24] mb-16">
                    <h3 className="text-3xl font-bold mb-6">Why Choose Rajkuruma Real Estate?</h3>
                    <p className="text-gray-700 mb-6">
                        We are committed to delivering trustworthy, transparent, and customer-focused services. With extensive market knowledge and professional guidance, we help you make informed decisions with confidence.
                    </p>
                    <div className="grid md:grid-cols-3 gap-4 font-bold text-[#0c24da]">
                        <p>✓ Market Expertise</p>
                        <p>✓ Transparent Process</p>
                        <p>✓ Dedicated Support</p>
                    </div>
                </div>

                {/* Final CTA */}
                <div className="text-center bg-[#1a2b4d] p-12 rounded-3xl text-white">
                    <h3 className="text-3xl font-bold mb-4">Looking for a Property?</h3>
                    <p className="mb-8">Let us help you find the perfect match for your needs.</p>
                    <Link to="/enquiry" className="bg-[#f15a24] hover:bg-[#d44d18] px-10 py-4 font-bold rounded-full text-lg transition">ENQUIRE NOW →</Link>
                </div>
            </div>
        </div>
    );
};

const SolutionCard = ({ title, desc, features }) => (
    <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition border-b-4 border-[#0c24da]">
        <h4 className="text-2xl font-bold text-[#0c24da] mb-3">{title}</h4>
        <p className="text-gray-600 mb-4">{desc}</p>
        <ul className="grid grid-cols-2 gap-2">
            {features.map((f, i) => <li key={i} className="text-sm text-gray-500 italic">▸ {f}</li>)}
        </ul>
    </div>
);

export default RealEstate;